import { MANIFESTO } from "@/data/site";
import { Reveal } from "@/components/common/Reveal";

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="bg-brand-accent text-white">
    <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-12 md:py-20 lg:px-20 lg:py-24">
      <div className="grid gap-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-12">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-green">
            Why Choose Us
          </span>
          <h2 className="mt-3 font-display text-3xl font-semibold leading-[1.05] tracking-tight md:text-4xl lg:text-5xl">
            A dentist who <span className="italic text-brand-green">listens</span>, explains, and
            treats you gently.
          </h2>
          <p className="mt-4 max-w-md text-sm text-white/60">
            Four principles guide every visit at our Paharia clinic — the reason patients across
            Varanasi trust Dr. Ankesh Seth with their smiles.
          </p>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2">
          {MANIFESTO.map((m, i) => (
            <Reveal
              key={m.no}
              delay={i * 0.08}
              className="rounded-2xl border border-white/10 bg-white/[0.03] p-5"
            >
              <span className="font-display text-lg text-white/40">{m.no}</span>
              <h3 className="mt-1 font-display text-lg font-medium md:text-xl">{m.title}</h3>
              <p className="mt-2 text-sm text-white/60">{m.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
